import { Button } from '@barfacil/barfacil-ui'
import { useNavigate } from 'react-router-dom'

import { Breadcrumb } from '@/app/panel/_components/breadcrumb'

export const TerminalsLayout = ({ children }: React.PropsWithChildren) => {
  const navigate = useNavigate()

  const handleBack = () => {
    navigate(`/cadastros/eventos`)
  }

  return (
    <section className="mb-4 flex size-full flex-col gap-4 sm:px-8">
      <Breadcrumb />

      {children}

      <footer className="mt-auto flex flex-col-reverse gap-4 sm:ml-auto sm:flex-row">
        <Button className="min-w-36" variant="tertiary" onClick={handleBack}>
          Voltar
        </Button>
        <Button className="min-w-36">Finalizar</Button>
      </footer>
    </section>
  )
}
